import mixpanel from 'mixpanel-browser';
let key = process.env.REACT_APP_ENV === 'PROD' ? '24352b1fa8ab9fce5e7883e9cb798906' : '4af6710f2c172496e367b956b261f905';
mixpanel.init(key);

let TRACKING_ACTIVE = true;  // Set to false if working in dev environment. Or use a snippet which evaluates to true in production like env === production

let actions = {
  identify: (id) => {
    if (TRACKING_ACTIVE) mixpanel.identify(id);
  },
  alias: (id) => {
    if (TRACKING_ACTIVE) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (TRACKING_ACTIVE) mixpanel.track(name, props);
  },
  track_links: (div, name, props) => {
    if (TRACKING_ACTIVE) mixpanel.track_links(div, name, props);
  },
  register: (props) => {
    if (TRACKING_ACTIVE) mixpanel.register(props);
  },
  people: {
    set: (props) => {
      if (TRACKING_ACTIVE) mixpanel.people.set(props);
    },
    increment: (props) => {
      if (TRACKING_ACTIVE) mixpanel.people.increment(props);
    },
  },
  resetUser: () => {
    if (TRACKING_ACTIVE) {
      mixpanel.reset();
      localStorage.removeItem("userSetForMixpanel");
    }
  }
};

export let Mixpanel = actions;

export const isEmpty = (obj) => {
  if (obj === undefined || obj === null || obj == 'undefined') {
    return true;
  }

  if (typeof obj === 'string' && obj.trim() === '') {
    return true;
  }

  if (Array.isArray(obj) && obj.length === 0) {
    return true;
  }

  if (typeof obj === 'object') {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  return false;
};


  // Define the event listener function
  export function disableShortcuts(event) {
    // Check if Ctrl + R or Ctrl + Shift + R or F12 or F5

    let endpointRegister = localStorage.getItem("isRegister");
    console.log("newscc");
    if (endpointRegister != "1") {
      console.log("undernewss");
    if (
      (event.ctrlKey || event.metaKey) && (event.key === 'r' || event.key === 'R') ||  // Ctrl + R or Ctrl + Shift + R
      event.key === 'F12' ||                                                           // F12
      event.key === 'F5'                                                               // F5
    ) {
      event.preventDefault(); // Prevent the default action
    }
  }
  }